
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 23">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M0.98877 8.55C0.98877 12.75 8.64253 22.725 9.88171 22.725C11.1209 22.725 18.7746 12.75 18.7746 8.55C18.7746 3.825 14.7655 0 9.88171 0C4.99788 0 0.98877 3.825 0.98877 8.55Z"
    fill="currentColor"
  ></path>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.30994 9C6.30994 11.1 7.98647 12.75 10.0275 12.75C12.0685 12.75 13.745 11.1 13.745 9C13.745 6.9 12.0685 5.25 10.0275 5.25C7.98647 5.25 6.30994 6.9 6.30994 9Z"
    fill="white"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Location',
    }) as DefineComponent
    </script>
    